import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LoaderModule, TooltipModule } from '../../components';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { MultiSelectBadgeComponent } from './multi-select/multi-select-badge.component';
import { SelectComponent } from './select.component';
import { SelectItemComponent } from './select-item.component';
import { SelectMenuComponent } from './select-menu.component';
import { SingleSelectComponent } from './single-select/single-select.component';

@NgModule({
  declarations: [
    SelectComponent,
    SelectMenuComponent,
    SelectItemComponent,
    SingleSelectComponent,
    MultiSelectComponent,
    MultiSelectBadgeComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    LoaderModule,
    TooltipModule,
    OverlayModule,
    PortalModule
  ],
  providers: [],
  exports: [
    SingleSelectComponent,
    MultiSelectComponent
  ]
})
export class SelectModule { }
